module.exports = __webpack_public_path__ + "static/img/Wong.b6533156.png";